import { IcExport } from '@assets/icons/24x24';
import { Icon, IconButton } from '@chakra-ui/react';
import { NotificationSearchExportDialog } from '@components/cockpit/panels/notificationSearch/export/NotificationSearchExportDialog';
import { useNotificationSearchContext } from '@components/cockpit/panels/notificationSearch/NotificationSearchContext';
import { Tooltip } from '@components/ui/tooltip';
import { useIntl } from 'react-intl';

export function NotificationSearchExportButton() {
  const { formatMessage } = useIntl();
  const { isOpenedExportDialog, setIsOpenedExportDialog } = useNotificationSearchContext();

  return (
    <>
      <Tooltip content={formatMessage({ id: 'components.notificationSearch.export.exportResults' })}>
        <IconButton
          aria-label="Download data"
          variant="cockpitHeader"
          boxSize="56px"
          data-active={isOpenedExportDialog}
          onClick={() => setIsOpenedExportDialog(true)}
        >
          <Icon as={IcExport} boxSize="24px" />
        </IconButton>
      </Tooltip>
      <NotificationSearchExportDialog />
    </>
  );
}
